<div class="specialities">
    <div class="title">
        <div class="tit">
            <h3>SZAKRENDELÉSEK</h3>
            <div class="add-icon">
                <mat-icon routerLink="/addspeciality">add_circle</mat-icon>
            </div>
        </div>
    </div>

    <div class="add-new-speciality">
        <div class="search-bar">
            <div class="search-tool">
                <input type="search" placeholder="Szakterület neve" [(ngModel)]="searchText" />
                <div class="icon">
                    <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
                </div>
            </div>
        </div>
    </div>
    <div class="speciality-container">
        <div class="speciality-c">
            @for (specialitySelectorItem of specialitySelectorItemList | filter: searchText; track
            specialitySelectorItem; let i = $index) {
            <div class="speciality">
                <div class="pro">
                    <div class="name" [ngStyle]="
                                i % 2 === 0 ? { background: 'white', border: '1px solid #ccc' } : { background: '#efeff5', border: 'black' }
                            ">
                        <div routerLink="/updatespeciality/{{ specialitySelectorItem.routerLink }}" class="button"
                            [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }">
                            {{ specialitySelectorItem.name }}
                        </div>
                        <mat-icon [ngStyle]="{ cursor: 'pointer' }"
                            (click)="openDeleteSpecialityDialog(specialitySelectorItem)">delete_forever</mat-icon>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>